import { render, staticRenderFns } from "./ManagePrice.html?vue&type=template&id=385c24fa&scoped=true&"
import script from "./ManagePrice.vue?vue&type=script&lang=js&"
export * from "./ManagePrice.vue?vue&type=script&lang=js&"
import style0 from "./ManagePrice.scss?vue&type=style&index=0&id=385c24fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c24fa",
  null
  
)

export default component.exports